import '~/util/polyfills';
import 'module-alias/register';
import express from 'express';
import dateFormat from 'dateformat';

import copyRouter from './routes/copy';
import deleteRouter from './routes/delete';
import diffRouter from './routes/diff';
import duplicateRouter from './routes/duplicate';
import getRouter from './routes/get';
import migrateRouter from './routes/migrate';
import recycleRouter from './routes/recycle';
import updateRouter from './routes/update';

import { startRecorder } from './mockingMiddleware';
import { Logger } from '~/util/logger';
import { formatSeconds } from '~/util/datetime';
import { LIB_VERSION } from '~/util/version';
import { cachePreview, cacheSize } from '~/providers/FileProvider';

const app = express();
const port = 3001;
const started = new Date();

// Domain structure:
//   /:operation/:entity/:commit?|:id?
// v1
//   Copy
//     Field
//   Duplicate
//     Projects?
//     Content types
//   Diff
//     Models
//   Delete
//     Components
//     Content types
//     TagGroups
//     Tags
//     Assets
//     Entries
//     Nodes
//   Get
//     Projects?
//     Keys
//     Roles
//     Content types
//     Components
//     TagGroups
//     Tags
//     Entries
//       All
//     Models
//   Migrate
//     Projects?
//     Components
//     Content types
//     TagGroups
//     Tags
//     Models
//     Assets
//     Entries
//     Nodes
//   Recycle
//     Entries
//   Update
//     Field

app.use(express.json());
app.use(
  express.urlencoded({
    extended: true,
  })
);
app.get('/', (req, res) => res.status(200).send());
app.use('/v1/migrate', migrateRouter);
app.use('/v1/copy', copyRouter);
app.use('/v1/duplicate', duplicateRouter);
app.use('/v1/diff', diffRouter);
app.use('/v1/delete', deleteRouter);
app.use('/v1/recycle', recycleRouter);
app.use('/v1/update', updateRouter);
app.use('/v1/get', getRouter);

// healthz endpoint for Kubernetes to ping
app.get('/healthz', (req, res) => res.status(200).send('OK'));

app.get('/ping', async (req, res) => {
  const [, size] = await cacheSize();
  const [, contents] = await cachePreview();

  res.send({
    name: `Migratortron-1000 v${LIB_VERSION}`,
    started: dateFormat(started, 'dd/mm/yyyy HH:MM:ss'),
    uptime: formatSeconds(process.uptime()),
    version: LIB_VERSION,
    cache: {
      size,
      contents,
    },
  });
});

app.post('/post-test', (req, res) => {
  Logger.info('POST request to /post-test');
  res.send({
    name: `Testing POST method`,
    body: req.body,
  });
});

app.use('/', (req, res) => {
  Logger.error(`[404] ${req.originalUrl}`);
  res.status(404).send({ error: 'Not found' });
});

const server = app.listen(port, () => {
  app.emit('ready');
  Logger.success(
    `
Migratortron-1000 service listening at http://localhost:${port}
  
The 1000 Series Migratortron is a fully autonomous advanced prototype. The M-1000 is made entirely out of a liquid metal called "mimetic polyalloy", meaning it can reform into any shape it touches of the approximate size. The usual modus operandi of the M-1000 is to impersonate found content types and components, only attacking once the target has been identified.

Ready to receive next target...
  `,
    true
  );

  // Nock http interceptor to record requests and write json files
  // in nock/recorded folder to use as mock requests with tests later
  startRecorder(!!process.env.RECORD_MOCKS);
});

app.on('stop', () => {
  server.close(() => Logger.info(`Exiting gracefully. I'll be back`));
});

export default app;
